import { useEffect, useReducer } from 'react'
import { createContext, useContext, useState } from 'react'
import {
  ListaClientes,
  ListaCondicaoPagamento,
  ListaContato,
  ListaDadosProposta,
  ListaEmpresas,
  ListaHistorico,
  ListaItensPropostas,
} from '../../../../services/api'
import { nextStepReducer } from '../reducers/product/nextStep'
import { productReducer } from '../reducers/product/reducer'

export const ProductContext = createContext()

const INITIAL_STATE_NEXT_STEP = []
const INITIAL_STATE_PRODUCT = []

export function ProductProvider({ children }) {
  const [dataProduct, dispatch] = useReducer(
    productReducer,
    INITIAL_STATE_PRODUCT
  )
  const [itemDuplicate, setItemDuplicate] = useState([])
  const [nextStep, dispatchNextStep] = useReducer(
    nextStepReducer,
    INITIAL_STATE_NEXT_STEP
  )
  const [listEnterprise, dispatchListEnterprise] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'LIST_ENTERPRISE':
          return action.payload
        default:
          return state
      }
    },
    []
  )
  const [listConditionPayment, dispatchConditionPayment] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'LIST_CONDITION_PAYMENT':
          return action.payload
        default:
          return state
      }
    },
    []
  )

  const [dataHistory, setDataHistory] = useState([])
  const [contactPartner, setContactPartner] = useState([])
  const [selectPartner, setSelectPartner] = useState({})
  const [openContactPartner, setOpenContactPartner] = useState(false)
  const [newPropost, setNewPropost] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const [codigoVendedor, setCodigoVendedor] = useState('')
  const [codUsu, setCodUsu] = useState(null)
  const [dadosOrcamento, setDadosOrcamento] = useState({})

  useEffect(() => {
    if (localStorage.getItem('authentication')) {
      setCodigoVendedor(
        JSON.parse(localStorage.getItem('authentication')).codigo_vendedor
      )
      setCodUsu(
        JSON.parse(localStorage.getItem('authentication')).codigo_usuario
      )
    }
  }, [])

  const [partner, setPartner] = useState([])
  const [freteChecked, setFreteChecked] = useState({
    checked: false,
    value: '',
  })

  function selectProduct(index) {
    if (index === selectedIndex) {
      setSelectedIndex(null)
    } else {
      setSelectedIndex(index)
    }
  }

  async function handleFilterProposta(codproposta, codvendedor) {
    const params = {
      codigo_proposta: codproposta,
      codigo_vendedor: parseInt(codvendedor),
      codigo_tipo_operacao: '',
    }

    const response = await ListaDadosProposta.post('', params)

    setDadosOrcamento(response.data)
  }

  async function handleListEnterprise() {
    const { data } = await ListaEmpresas.get()

    dispatchListEnterprise({ type: 'LIST_ENTERPRISE', payload: data })
  }

  function handleNextStep(data) {
    dispatchNextStep({ type: 'NEXT_STEP', payload: data })
  }

  async function handleDataHistory(numeroProposta) {
    const { data } = await ListaHistorico.post('', {
      numero_proposta: numeroProposta,
    })

    setDataHistory(data)
  }

  async function handleListConditionPayment(codparc) {
    const { data } = await ListaCondicaoPagamento.post('', {
      codigo_parceiro: codparc,
    })

    dispatchConditionPayment({ type: 'LIST_CONDITION_PAYMENT', payload: data })
  }

  async function getContactPartner(codparc, texto) {
    const response = await ListaContato.post('', {
      codigo_parceiro: codparc,
      texto_buscado: texto,
    })

    setContactPartner(response.data)
  }

  function handleFreteChecked(checked, value) {
    setFreteChecked({ checked, value })
  }

  async function getInfoPartner(e) {
    const response = await ListaClientes.post('', e)

    setPartner(response.data)
  }

  async function getInfoProduct(numeroProposta) {
    const param = {
      codigo_proposta: numeroProposta,
      codigo_vendedor: '',
    }
    const response = await ListaItensPropostas.post('', param)
    const data = response.data

    //verifica se tem 2 ou mais codigo_produto iguais, se tiver, coloca no array de duplicados, se não, coloca no array de itens

    const isDuplicated = data.filter((item, index, self) => {
      return (
        self.findIndex((t) => t.codigo_produto === item.codigo_produto) !==
        index
      )
    })

    if (isDuplicated.length > 0) {
      //seta no array de duplicados, com o atributo duplicado = true
      setItemDuplicate(
        ...itemDuplicate,
        isDuplicated.map((item, index) => {
          return {
            ...item,
            duplicado: true,
            index: new Date().getTime() + index,
          }
        })
      )
    }

    dispatch({ type: 'GET_INFO_PRODUCT', payload: data })
  }

  function duplicateItem(item) {
    createItem(item)

    const newItem = {
      ...item,
      duplicado: true,
      index: new Date().getTime(),
    }

    setItemDuplicate([...itemDuplicate, newItem])
  }

  function createItem(item) {
    const newItem = {
      ...item,
      nome_produto: item.nome,
      codigo_produto: item.codigo,
      quantidade: 1,
      valor_unitario: item.valor,
      valor_total: item.valor,

      duplicado: false,
    }

    dispatch({ type: 'CREATE_ITEM', payload: newItem })
  }

  function removeItem(index) {
    const itemRemoved = itemDuplicate.filter((item) => item.index !== index)

    setItemDuplicate(itemRemoved)
  }

  return (
    <ProductContext.Provider
      value={{
        dataProduct,
        duplicateItem,
        removeItem,
        getInfoProduct,
        handleFreteChecked,
        freteChecked,
        setFreteChecked,
        getInfoPartner,
        partner,
        handleNextStep,
        nextStep,
        handleFilterProposta,
        dadosOrcamento,
        handleListEnterprise,
        listEnterprise,
        handleListConditionPayment,
        listConditionPayment,
        handleDataHistory,
        dataHistory,
        getContactPartner,
        contactPartner,
        setSelectPartner,
        selectPartner,
        setOpenContactPartner,
        openContactPartner,
        setNewPropost,
        newPropost,
        selectProduct,
        selectedIndex,
        createItem,
        itemDuplicate,
        codUsu,
      }}
    >
      {children}
    </ProductContext.Provider>
  )
}

export function useProduct() {
  const context = useContext(ProductContext)

  return context
}
